import { render, staticRenderFns } from "./collectStep3.vue?vue&type=template&id=189d03d9&scoped=true&"
import script from "./collectStep3.vue?vue&type=script&lang=ts&"
export * from "./collectStep3.vue?vue&type=script&lang=ts&"
import style0 from "./collectStep3.vue?vue&type=style&index=0&id=189d03d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189d03d9",
  null
  
)

export default component.exports